import { BaseApi } from "../shared/api";
import * as apiUrls from "./apiUrls";

import { notify, closeModal, stopLoading } from '../shared/actions';

export const submitReferral = (payload) => {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch);

    return api.postRequest(
      apiUrls.referralInvites(),
      payload,
      response => {
        dispatch(stopLoading('referralModal'));
        dispatch(closeModal('referralModal'));
        dispatch(
          notify({
            header: "Thank you for submitting!",
            body: "You can send more referrals below",
            className: '-success'
          })
        );
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/referrals/actions.js